import { FieldPath, deleteField, serverTimestamp } from 'firebase/firestore';

// Timeline event ids are uuid4 strings whose hyphens are illegal in dotted
// string field paths, so every timeline_review write must go through these
// FieldPath helpers, never template-string paths (same lesson as factPaths).

export function reviewFieldPath(eventId, ...rest) {
    return new FieldPath('timeline_review', eventId, ...rest);
}

/**
 * One timeline_review entry. reviewed_at stays for existing readers and
 * equals review.reviewedAt (D6).
 */
export function reviewEntry(decision, correctedStatus, stamp) {
    return {
        decision,
        corrected_status: correctedStatus,
        reviewed_at: stamp.reviewedAt,
        review: stamp,
    };
}

/**
 * updateDoc varargs for one event's review decision.
 *
 * @param {string} eventId
 * @param {'confirmed'|'dismissed'|null} decision - null clears the entry
 * (un-review).
 * @param {string|null} correctedStatus - status override, or null to keep
 * the extracted status.
 * @param {Object} stamp - reviewStamp() result; required when decision is set.
 */
export function eventReviewArgs(eventId, decision, correctedStatus = null, stamp = null) {
    if (!decision) {
        return [
            reviewFieldPath(eventId), deleteField(),
            new FieldPath('last_modified_date'), serverTimestamp(),
        ];
    }
    return [
        reviewFieldPath(eventId), reviewEntry(decision, correctedStatus, stamp),
        new FieldPath('last_modified_date'), serverTimestamp(),
    ];
}

/**
 * updateDoc varargs bulk-confirming every event that has no review entry.
 * Returns null when nothing needs confirming.
 *
 * @param {Array<Object>} events - Timeline events from the case doc.
 * @param {Object} existingReview - Current timeline_review map.
 * @param {Object} stamp - reviewStamp() result with bulk: true.
 */
export function confirmAllArgs(events, existingReview, stamp) {
    const rev = existingReview || {};
    const args = [];
    (events || []).forEach((e) => {
        if (!e?.id || rev[e.id]?.decision) return;
        args.push(reviewFieldPath(e.id), reviewEntry('confirmed', null, stamp));
    });
    if (args.length === 0) return null;
    args.push(new FieldPath('last_modified_date'), serverTimestamp());
    return args;
}
